var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.82,
    height: 11.517,
    viewBox: "0 0 13.82 11.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(0 -42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104266",
    "data-name": "Group 104266",
    transform: "translate(0 42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104265",
    "data-name": "Group 104265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64150",
    "data-name": "Path 64150",
    d: "M12.668,44.394H9.789v-.576a1.153,1.153,0,0,0-1.152-1.152H5.182a1.153,1.153,0,0,0-1.152,1.152v.576H1.152A1.153,1.153,0,0,0,0,45.545v1.727a1.153,1.153,0,0,0,1.152,1.152H5.758v-.288a.288.288,0,0,1,.288-.288H7.774a.288.288,0,0,1,.288.288v.288h4.607a1.153,1.153,0,0,0,1.152-1.152V45.545A1.153,1.153,0,0,0,12.668,44.394Zm-4.031,0H5.182v-.576H8.637Z",
    transform: "translate(0 -42.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64151",
    "data-name": "Path 64151",
    d: "M13.66,266.414a.288.288,0,0,0-.3.028,1.137,1.137,0,0,1-.69.237H8.062v.864a.288.288,0,0,1-.288.288H6.046a.288.288,0,0,1-.288-.288v-.864H1.152a1.137,1.137,0,0,1-.69-.237.288.288,0,0,0-.462.229v4.038a1.153,1.153,0,0,0,1.152,1.152H12.668a1.153,1.153,0,0,0,1.152-1.152v-4.038A.288.288,0,0,0,13.66,266.414Z",
    transform: "translate(0 -260.345)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.d46d476a1d503ae4d855bb76323dc39a.svg";
export { ForwardRef as ReactComponent };